import type { ButtonProps } from '@/components/ui/button';
import { Button } from '@/components/ui/button'
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { ChevronDown } from 'lucide-react'
import { type FC } from 'react'

interface DropdownButtonProps {
	options?: any[]
	onOptionSelected?: (option: any) => void
	renderOption?: (option: any) => string
	label: string
	buttonProps?: Omit<ButtonProps, 'children' | 'onClick'>
}

export const DropdownButton: FC<DropdownButtonProps> = ({
	options = [],
	onOptionSelected,
	label,
	renderOption,
	buttonProps,
}) => {
	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button {...buttonProps}>
					{label}
					<ChevronDown className="ml-2 h-4 w-4" />
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent align="end">
				{options.map((option) => (
					<DropdownMenuItem key={JSON.stringify(option)} onClick={() => onOptionSelected?.(option)}>
						{renderOption?.(option) ?? option}
					</DropdownMenuItem>
				))}
			</DropdownMenuContent>
		</DropdownMenu>
	)
}
